import * as angular from "angular";
import {QuantitySettingType} from "../types/quantitySetting.type";

const types = [
  QuantitySettingType.Surcharge,
  QuantitySettingType.SurchargePercentage,
  QuantitySettingType.Discount,
  QuantitySettingType.DiscountPercentage,
  QuantitySettingType.TotalFixedPrice
];


angular
  .module('bringoz.admin.pricePlan')
  .constant('quantitySettingConstants', {
    types : types
  });
